import { useEffect, useRef } from 'react'

/**
 *  Sets interval timer with provided callback, 0s - timer doesn't start; returns cancel function
 */
export function useInterval(cb: () => void, intervalSeconds: number) {
  const interval = useRef<NodeJS.Timeout | null>(null)

  const cancel = () => {
    if (interval.current) {
      clearInterval(interval.current)
    }
  }

  useEffect(() => {
    if (typeof window === 'undefined' || interval.current || !intervalSeconds) {
      return
    }

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    interval.current = setInterval(cb, intervalSeconds * 1000)
  }, [cb, intervalSeconds])

  return cancel
}
